<template>
  <div>
    <pc-navbar/>
  
    <div class="paySubmitSuccess bg_fff">

      <div class='head text_center'>
        <div class="iconfont iconwancheng color_red"></div>
        <div class="title f_24 color_40" style="margin-bottom:10px!important">购买成功</div>
        <div class="text f_16 color_666" style="margin-top:24px">你会收到导师服务进度通知，请注意助教老师微信提醒</div>
      </div>

      <div class="orderCont f_14" style="margin-top:20px">
        <div class="order_item ">
          <div class="item_title">服务名称：</div>
          <div class="item_detail ">
            <div>{{orderData.display_plan}}</div>
          </div>
          
        </div>
        <div class="order_item ">
          <div class="item_title">服务内容：</div>
          <div class="item_detail ">
            <div v-if="orderData.cv_optimization">【简历优化】</div>
            <div >{{orderData.interview_guidance ? '【面试辅导】': ''}}</div>
            <div >{{orderData.resume_submission ? '【简历代投】': ''}}</div>
            <div >{{orderData.discount_monthly_card ? '【特惠月卡】': ''}}</div>
            <div >{{orderData.interview_simulation ? '【职业咨询】': ''}}</div>
            <div >{{orderData.career_plan ? '【职业规划】': ''}}</div>
            <!-- <div >{{orderData.defect_repair ? '【瑕疵修复】': ''}}</div> -->
          </div>
        </div>
        <div class="order_item ">
          <div class="item_title">服务条件：</div>
          <div class="item_detail ">
            <div >{{orderData.degree_desc ? '【'+orderData.degree_desc+'】': ''}}</div>
            <div >{{orderData.industry_desc ? '【'+orderData.industry_desc+'】': ''}}</div>
            <div >{{orderData.cv_lang_desc ? '【'+orderData.cv_lang_desc+'】': ''}}</div>
            <div >{{orderData.urgency_desc ? '【'+orderData.urgency_desc+'】': ''}}</div>
            <!-- <div >{{orderData.defect_repair ? '【职业经历瑕疵修复】': ''}}</div> -->
             <!-- <div >{{orderData.mentor_type=='是' || orderData.mentor_type=='en' ? '【有海外经历】': '【无海外经历】'}}</div> -->
            <div >{{orderData.change_profession_desc ? '【'+orderData.change_profession_desc+'】': '【'+orderData.custom_industry+'】'}}</div>
            <!-- <div >{{orderData.work_year_desc ? '【'+orderData.work_year_desc+'】': ''}}</div> -->
            
          </div>
          
        </div>
        <div class="order_item" v-if="orderData.cv_optimization">
          <div class="item_title">选择简历：</div>
          <div class="item_detail ">
            <div class="resume ellipsis" @click="goToEdit(orderData.cn_cv.token)" v-if="orderData.cn_cv && orderData.cn_cv.name">
              <span>{{orderData.cn_cv?orderData.cn_cv.name:''}}</span>
            </div>
            <div class="resume ellipsis" @click="goToEdit(orderData.en_cv.token)" v-if="orderData.en_cv && orderData.en_cv.name">
              <span>{{orderData.en_cv?orderData.en_cv.name:''}}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="textCont color_9c f_14">
        <p>导师辅导说明：</p>
        <p>1. 超级简历导师修改服务由来自高盛、美世咨询、谷歌、BAT以及各大五百强公司的顶级导师提供简历辅导；</p>
        <p>2. 导师会针对你的提问进行解答，并且对于简历整体内容和求职方向提供点评；</p>
        <p>3. 详细指导包括对每一段经历的必要性、排序、篇幅、重点、细节提供建议，并且对于一些错别字、格式错误、模糊描述会直接修改或标注。</p>

        <p></p>

        <p>导师辅导流程：</p>
        <p>1. 下单后我们会审核你的简历，如遇到不符合要求的简历（比如缺失信息过多，和引导填写内容差异过大等）导师有可能会拒绝帮你进行修改辅导；</p>
        <p>2. 导师确认订单后会帮你创建一份新的导师辅导简历，并开始排上导师辅导日程；</p>
        <p>3. 一般导师反馈时间为3天，加急会1天内反馈，导师提交会发送邮件/信息通知；</p>
        <p>4. 进入“我的简历”即可查看导师修改后的简历，左侧为导师的回复和建议，右侧为导师修改后的简历。</p>
      </div>

    </div>
  </div>
</template>
<script>
  import api from '@/api';
  import { mapGetters, mapActions } from 'vuex'
  import { routerTo, get_tUser } from '@/assets/js/util';
  import PcNavbar from '@/components/base/navbar';
  export default {
    name: 'paySubmitSuccess',
    layout:'notTop',
    data(){
      return {
        orderData:{},
      }
    },
    components:{
      PcNavbar
    },
    created() {
      console.log(11)
      this.$store.dispatch('app/setNavbarAction', '简历修改');
      // 8a5a7647-aad5-481b-94d7-d6b2ebdfc872
      this._c_t = get_tUser().c_t || '';
      let { token=''} = this.$route.params;
      this.order_token = token;

      //检查是否登录
      if(!this._c_t){
        //未登录
        routerTo('/signin?type=login')
        return false;
      }
      //获取页面信息
      this.getOrderData();
    },
    methods: {
      //获取页面信息
      getOrderData(){
        api.mentorOrders.mentorOrdersEdit(this.order_token) .then(res => {
          console.log(res)
          if(res.code === 1000){
            this.orderData = res.data;
          }else{
            this.$message.error(res.message)
            setTimeout(() => {
              window.location.href = window.location.origin + '/account/users?index=3'
            }, 1000);
          }
        })
        .catch(err => {
        
        })
      },
      // 去简历编辑页面
      goToEdit(token) {
        routerTo(`/cvs/${token}/editor`)
      }
    }
  }
</script>
<style lang="scss" scoped>
  // 公共初始化样式
  @import '~/assets/css/public';
  @import './index.scss';
  
  .paySubmitSuccess .head .iconfont {
    margin-bottom: 10px;
  }
  .order_item {
    margin-top: 27px;
    display: flex;
    justify-content: space-between;
    width: 398px;
    margin-left: -70px;
    .item.title {
      font-weight:400;
      font-size:14px;
      color:rgba(64,64,64,1);
    }
    .item_detail {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      justify-content: flex-end;
      width: 300px;
      font-weight:400;
      width: 320px;
      font-size:14px;
      color:rgba(156,156,156,1);
      div{
        line-height: 20px;
        // &:nth-child(3),
        // &:nth-child(4) {
        //   margin-top: 6px;
        // }
        // float: right;
      }
    /*  display: flex;
     justify-content: flex-start;
      //overflow: hidden;
      font-weight:400;
      width: 335px;
      font-size:14px;
      color:rgba(156,156,156,1);
      div{
        margin-left: 10px;
       // float: right;
      } */
      .resume {
        font-size:14px;
        font-weight:400;
        color:rgba(255,102,68,1);
        line-height:14px;
        cursor: pointer;
        margin-bottom: 22px;
        // float: initial;
        text-align: right;
        span{
          border-bottom: 1px solid rgba(255,102,68,1);
          display: inline-block;
        }
      }
    }
  }
</style>
